import React, { useState, useEffect } from "react";
import InputField from "../../component/input-field";
import Select from "react-select";
import "../../css/theme.css";
import { Country } from "country-state-city";
import { useDispatch, useSelector } from "react-redux";
import { getTimeZoneForOnboarding } from "../../redux/actions/onboarding";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../component/modal-popup/customeModal";

function OnboardingSlide4({
  formik,
  FieldArray,
  FormikProvider,
  Form,
  errorForSlide4,
  setErrorForSlide4,
}) {
  const dispatch = useDispatch();
  const [countries, setCountries] = useState();
  const [timeOptions, setTimeOptions] = useState([]);

  const { time_zone_for_onboarding } = useSelector((state) => state.onboarding);

  useEffect(() => {
    const request = {
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getTimeZoneForOnboarding(request));
    // const country = Country.getAllCountries();
    // const list = [];
    // country?.map((item) => list.push({ value: item.name, label: item.name }));
    // setCountries(list);
  }, []);

  useEffect(() => {
    if (time_zone_for_onboarding.length > 0) {
      const arr = [];
      time_zone_for_onboarding.map((element) => {
        const obj = {
          label: element.timezone,
          value: element.timezone_id,
        };
        arr.push(obj);
      });
      setTimeOptions(arr);
    }
  }, [time_zone_for_onboarding]);

  useEffect(() => {
    if (errorForSlide4) {
      setTimeout(() => {
        setErrorForSlide4(!errorForSlide4);
      }, 2000);
    }
  }, [errorForSlide4]);

  return (
    <div
      className="px-16 pt-16 space-y-4 h-full"
      style={{ maxHeight: "calc(100% - 80px)" }}
    >
      <div className="h-full grid grid-cols-2 gap-4">
        <div className="space-y-4">
          <div className="block w-[60px]">
            <img
              alt="Logo"
              src={require("../../assets/img/ShiproneLogo.png")}
            />
          </div>
          <div>
            <p className="font-bold text-2xl leading-9 tracking-tight">
              Lets Create
            </p>
            <p className="font-bold text-2xl leading-9 tracking-tight">
              Some of Your <span className="text-[#2f80ed]">Team</span>
            </p>
          </div>
          <div className="w-3/4">
            <p className="text-base leading-6 tracking-tight text-[#1E293B]">
              What teams (departments) do you have in your organisation?
            </p>
          </div>
          <div>
            <a
              href="https://meetings.hubspot.com/abidwai/shiperone-workflow-demo"
              target="__blank"
              className="text-[#2f80ed] border-b border-[#2f80ed] font-semibold text-sm leading-10 tracking-tight py-2"
            >
              Schedule Personal Onboarding
            </a>
          </div>
        </div>
        <div className="h-full space-y-1">
          {errorForSlide4 && (
            <div className="bg-[#D313131A]/10 px-3 py-2 rounded-2xl -mt-8 space-x-2 flex items-center">
              <span className="fa-solid fa-circle-exclamation fill-current text-base text-[#D31313]"></span>
              <span className="text-[13px] text[#383C43] font-medium leading-4 tracking-tight">
                Please provide the team name and location for at least one
                field.
              </span>
            </div>
          )}

          <div 
          className="h-[384px] overflow-y-auto bg-[#F2F8FE] rounded-[20px] text-center px-10 py-4"
          // style={{maxHeight: 'calc(100% - 20px)'}}
          >
            <FormikProvider value={formik}>
              <Form
                autoComplete="off"
                noValidate
                onSubmit={formik.handleSubmit}
              >
                <FieldArray
                  name="teamData"
                  render={(arrayHelpers) => (
                    <div>
                      {formik.values.teamData.map((item, index) => {
                        return (
                          <div key={index}>
                            <div className="py-2">
                              <InputField
                                type="text"
                                name="team_name"
                                label={`Team ${index + 1}`}
                                placeholder="Enter Team Name"
                                value={formik.values.teamData[index].team_name}
                                onChange={(e) =>
                                  formik.setFieldValue(
                                    `teamData[${index}].team_name`,
                                    e.target.value
                                  )
                                }
                                onBlur={formik.handleBlur}
                              />
                              <Select
                                className="unresetText text-left"
                                placeholder="Select Time Zone"
                                menuPortalTarget={document.body}
                                menuPlacement="top"
                                options={timeOptions}
                                value={formik.values.teamData[index].timezone_id}
                                 onChange={(newValue) =>
                                  formik.setFieldValue(
                                    `teamData[${index}].timezone_id`,
                                    newValue
                                  )
                                }
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  placeholder: (provided, state) => ({
                                    ...provided,
                                    color: "#9B9B9B", // Set your desired color here
                                  }),
                                }}
                                classNames={{
                                  control: (style) => {
                                    return `!border !shadow-sm ${
                                      style.isFocused
                                        ? "!border-[--bg-color-300]/50"
                                        : "!border-slate-200 hover:!border-gray-300"
                                    }`;
                                  },
                                  container: (style) => {
                                    return "!h-[37.5px] !font-inter !text-sm";
                                  },
                                  menuList: (style) => {
                                    return `!max-h-[200px]`;
                                  },
                                }}
                              />

                              {/* <Select
                                menuPortalTarget={document.body}
                                className="unresetText text-left text-sm"
                                name="team_location"
                                options={countries}
                                isClearable
                                value={
                                  formik.values.teamData[index].team_location
                                }
                                classNames={{
                                  control: (style) => {
                                    return `!border !shadow-sm ${
                                      style.isFocused
                                        ? "!border-[--bg-color-300]/50"
                                        : "!border-slate-200 hover:!border-gray-300"
                                    }`;
                                  },
                                  container: (style) => {
                                    return "!h-[37.5px] !font-inter !text-sm";
                                  },
                                  menuList: (style) => {
                                    return `!max-h-[200px]`;
                                  },
                                }}
                                onChange={(newValue) =>
                                  formik.setFieldValue(
                                    `teamData[${index}].team_location`,
                                    newValue
                                  )
                                }
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  placeholder: (base) => ({
                                    ...base,
                                    color: "#9B9B9B",
                                  }),
                                }}
                                placeholder="Select Team Location"
                              /> */}
                            </div>
                          </div>
                        );
                      })}
                      <div className="flex justify-start">
                        <p
                          className={`text-[11px] font-semibold leading-3 text-[#2f80ed] cursor-pointer
                        `}
                          onClick={(e) => {
                            arrayHelpers.push({
                              team_name: null,
                              team_location: null,
                            });
                          }}
                        >
                          <i
                            className={`fas fa-plus text-[11px] pr-2 text-[#2f80ed] cursor-pointer`}
                          ></i>
                          Add Team
                        </p>
                      </div>
                    </div>
                  )}
                />
              </Form>
            </FormikProvider>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnboardingSlide4;
